angular.module('impactx.cscontract').controller('CSCCommonListCtrl', [
    'selectedListItems',
    CSCCommonListCtrl
]);

function CSCCommonListCtrl(selectedListItems) {
    var self = this;
    const CONTRACT_TYPE_MASTER = "2";

    self.getDetailLink = function () {
        return 'csccommonrelationlist/' + selectedListItems.getFirstSelectedId();
    }

    self.canSeeDetailLink = function () {
        return selectedListItems.isSingleSelection() &&
            impactX.isDefined(selectedListItems.getFirstSelectedItem(), 'contractTypeNr') !== CONTRACT_TYPE_MASTER;
    }

    var buttonDefinition = [
        {
            label: "companies",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: self.canSeeDetailLink,
            process: 'ViewCSC'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/cscontract/templates/csccommonlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/cscontract/basiccontract/list',
        id: "cscCommonList",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    self.getMeta = function () {
        return self.meta;
    };
}